<template>
    <div class="menu">

        <div>
            <div class="user">
                <div class="user__img">
                    <img v-if="user.picture" :src="getFile(user.picture,'user')">
                    <img v-else src="@\assets\user.png" alt="">
                </div>
                <span class="user__name">{{user.firstName}} {{user.lastName}}</span>
            </div>

            <div class="main-nav">
                <router-link to="/" @click.stop="toggleMenu()" :class="{'active': route.name == 'HOME'}"><span>{{ $t('nav.HOME') }}</span></router-link> 
                <router-link v-if="user.permissions.includes('CURSO_VER_PROPIOS')" to="/my-courses" @click.stop="toggleMenu()" :class="{'active': route.name && route.name.includes('COURSE')}"><span>{{ $t('nav.COURSES') }}</span></router-link>
                <router-link v-if="user.role.toLowerCase() === 'learninguser' && user.type?.toLowerCase() == 'docente'" to="/profile" @click.stop="toggleMenu()" :class="{'active': route.name && route.name.includes('profile')}"><span>{{ $t('nav.PROFILE') }}</span></router-link>
                <span v-if="(user.profiles.length > 1)"  @click="modalSwitchRole.active = true; modalSwitchRole.error = false" >{{ $t('nav.PROFILES') }}</span>
                <router-link to="/contents/mastercourses" @click.stop="toggleMenu()" v-if="user.permissions.includes('ACCESO_CONTENIDO')">{{ $t('nav.CONTENTS') }}</router-link>
                <router-link to="/management/preinscriptions" v-if="managementViewConditions.some(condition => user.role.includes(condition))" @click.stop="toggleMenu()">{{ $t('nav.MANAGEMENT') }}</router-link>
                <template v-if="!(user.role?.toLowerCase() === 'learninguser' && user.type?.toLowerCase() === 'joven')">
                    <router-link v-if="user.permissions.includes('RECURSO_VISUALIZACION')" to="/resources" @click.stop="toggleMenu()" :class="{'active': route.name == 'RESOURCES'}"><span>{{ $t('nav.RESOURCES') }}</span></router-link> 
                </template>
            </div>
        
        </div>

        <div>
            <div class="help" @click.stop="openHelpModal()"><i class="material-icons">help</i><span>{{ $t('nav.HELP') }}</span></div>
            <span class="logout" @click.stop="logout()"><i class="material-icons">logout</i>{{$t('nav.LOG_OUT')}}</span>
        </div>

        <template v-if="modalSwitchRole.active">
            <div class="modal__overlay">
            <!-- <template v-if="modalSwitchRole.awaitRequest" >
                <Loader />
            </template> -->
            <div class="modal">
                <div class="modal__close"><i class="material-icons" @click.stop="modalSwitchRole.active = false">close</i></div>
                <div class="pickRole">
                    <h3>{{$t('pickrole.TITLE')}}</h3>
                    <h5>{{ $t('pickrole.INSTRUCTION') }}</h5>
                    <div class="pickRole__error" v-if="modalSwitchRole.error"><i class="material-icons">error_outline</i> {{ $t('pickrole.ERROR') }}</div>
                    <div class="pickRole__roles">
                        <div class="pickRole__role" 
                        :class="{'pickRole__role--selected' : user.role == role.role, 'pickRole__role--newRoleAnimation' : modalSwitchRole.newRoleAssigned == role.role && modalSwitchRole.awaitRequest}" 
                        v-for="(role, index) in user.profiles" 
                        :key="index" 
                        @click.stop="user.role !== role.role && !modalSwitchRole.awaitRequest && pickRole(role.role)"
                        >
                            <i class="material-icons-outlined">
                                {{ 
                                    role.role === 'TUTOR' ? 'supervised_user_circle' : 'menu_book'
                                }}
                            </i>
                            {{$t(`role.${role.role}`)}}<i v-if="user.role === role.role" class="material-icons-outlined done">done</i>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </template>


    </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, inject, ref } from 'vue';
export default {
    setup(_, {emit}) {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const getFile = inject("getFile");
        const user = computed(() => store.getters.manageUser_user);
        const menuMobile = inject('menuMobile');
        const managementViewConditions = ['GESTOR_PLATAFORMA', 'COORDINADOR_PEDAGOGICO', 'COORDINADOR_ACADEMICO', 'ADMINISTRADOR']
        const modalSwitchRole = ref({
          active: false,
          error: false,
          awaitRequest: false,
          newRoleAssigned: undefined
        });

        function openHelpModal(){
            emit('openHelpModal')
        }

        function toggleMenu() {
            emit('toggleMenuMobile');
        }

        async function logout() {
            try {
                await store.dispatch("manageUser_disabled");
                router.push("/login");
                menuMobile.value = false;
            } catch (error) {
                console.log('Redirección realizada o error en la acción:', error.message);
            }
        }

        async function pickRole(role) {
            if (modalSwitchRole.value.awaitRequest)
                return;
            try {
                modalSwitchRole.value.error = false;
                modalSwitchRole.value.awaitRequest = true;
                modalSwitchRole.value.newRoleAssigned = role
                const delay = ms => new Promise(res => setTimeout(res, ms));
                await delay(2000);
                await store.dispatch("manageUser_pickRole", role);
                modalSwitchRole.value.awaitRequest = false;
                router.go(route.fullPath)
            }
            catch (error) {
                console.log(error);
                modalSwitchRole.value.error = true;
                modalSwitchRole.value.functionFinished = true
                modalSwitchRole.value.awaitRequest = false;
            }
        }

        return {
            openHelpModal,
            route,
            getFile,
            user,
            toggleMenu,
            logout,
            modalSwitchRole,
            pickRole,
            managementViewConditions
        }

    }
    
}
</script>


<style lang="scss" scoped>
@import "@/styles/main.scss";
.menu{
    border-top: 1px solid $black;
    background: #fff;
    position: absolute;
    top: 7vh;
    bottom: 0px;
    width: 100vw;
    height: 93vh;
    padding: 16px;
    padding-bottom: 20px;
    z-index: 3000;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .user{

        padding-bottom: 20px;
        margin-bottom: 36px;
        display: flex;
        align-items: center;
        gap: 14px;
        border-bottom: 2px solid #f7f7f7;
        &__img {
            position: relative;
            width: 72px;
            height: 72px;
            flex-shrink: 0;
            border-radius: 100%;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                cursor: pointer;
            }
        }
        &__name{
            font-size: 24px;
            color: $green;
            font-weight: 600;
        }
    }
    .main-nav{
        padding-left: 24px;
        display: flex;
        flex-direction: column;
        gap: 42px;
        a, span{
            display: inline-flex;
            align-items: center;
            gap: 12px;
            color: $black;
            text-decoration: none;
            font-size: 26px;
            font-weight: 600;
           /*  &:last-child{
                gap: 1px;
            } */
            &:hover, &.active{
                color: $green;
            }
            .material-icons{
                font-size: 36px;
            }
            span{
                font-size: 26px;
                font-weight: 600;
            }
        }
    }
    .help{
        display: flex;
        color: $black;
        align-items: center;
        justify-content: center;
        gap: 6px;
        .material-icons{
            font-size: 24px;           
            }   
        span{
            font-size: 20px;
            font-weight: 600;
        }      
    }
    .logout {
        margin-top: 16px;
        padding: 20px 0 8px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 22px;
        font-weight: 500;
        border-top: 2px solid #f7f7f7;
        i{
            font-size: 26px;
            transform: rotate(180deg);
        }
    }
}

.pickRole{
  h3{
    font-size: 22px;
    font-weight: 700;
  }
  h2{
    font-size: 16px;
    font-weight: 500;
  }
  width: 100%;
  padding-bottom: 24px;
  min-height: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  gap: 12px;
  &__roles{
    width: 100%;
  }
  &__role{
    background: linear-gradient(to right, rgba(189, 228, 228, 0.5) 50%, $lightgray 50%);
    background-size: 200% 100%;
    background-position: right bottom;
    transition: background-position 2s ease-out;
    &--selected{
      background: rgba(189, 228, 228, 0.5);
      color: #009696;
    }
    &--newRoleAnimation{
      color: $green;
      animation-name: newRoleLoader;
      animation-duration: 2s;
      animation-fill-mode: forwards;
      @keyframes newRoleLoader {
        from{
          background-position: right bottom;
          color: $black;
        }
        to {
          background-position: left bottom;
          color: $green;
        }
      }
    }
  }
}
</style>